var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('div',{staticClass:"dashboard-tabs"},[(_vm.tab === 'details')?_c('Information'):_vm._e(),(_vm.tab === 'recommendations')?_c('Recommendations'):_vm._e(),(_vm.tab === 'report')?_c('ReductionReport'):_vm._e()],1):_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }